export const documentAuditPath = 'tasks';
export const documentTask = 'task/:nid';
export const documentsVisualizer = 'visualizer';
export const reassignTasks = 'reassign-tasks';
export const georeferencing = 'georeferencing';
